import { UITabs } from 'shared/components/Tabs';
import { UITab } from 'shared/components/Tabs/Tab';
import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ComercialPolitics } from 'utils/Constants/ComercialPolitics';

interface ListClientsTabsProps {
  onChange: (step: string) => void;
}

export function ListClientsTab({ onChange }: ListClientsTabsProps) {
  const [step, setStep] = useState('all');

  const handleChange = (event: React.SyntheticEvent, value: string) => {
    setStep(value);
    onChange(value);
  };

  return (
    <>
      <UITabs value={step} onChange={handleChange}>
        <UITab value={'all'} label={'Todos'} />
        {ComercialPolitics.map((clientType) => (
          <UITab value={clientType} label={clientType} />
        ))}
        <Box flex="1" />
        <UITab value="inactive" label={'Inativo'} />
      </UITabs>
    </>
  );
}
